<div class="agpr-searchSourcePicker">
    <div class="agpr-searchSourcePicker-header">
        {{ 'Sources.sourcePicker.header' | localize }}
    </div>
    <div class="agpr-searchSourcePicker-content">
        <div
            class="agpr-searchSourcePicker-existing"
            [ngClass]="{'agpr-searchSourcePicker-existing--withChips': existingSourceChips && existingSourceChips.length}"
        >
            <agpr-autocomplete
                [id]="id + '_autoComplete'"
                [placeholder]="'Sources.sourcePicker.existing.placeholder'"
                [dropdown]="true"
                [(ngModel)]="selectedSource"
                (itemSelected)="selectExistingSource($event)"
                [suggestions]="sourceList$"
                ariaLabel="Source.selectSource"
                panelStyleClass="p-autocomplete-panel-fullWidth"
                label="Sources.sourcePicker.existing"
                [itemTemplate]="sourceTemplate"
                [forceClearAfterSelection]="true"
                labelField="name"
            ></agpr-autocomplete>
            <ng-template #sourceTemplate let-source>
                <div class="agpr-autocomplete-item agpr-searchSourcePicker-source">
                    {{ source.name }} <span class="agpr-searchSourcePicker-source-type" style="font-style: italic; color: #5e6473;">{{ 'Sources.type.' + source.type | localize }}</span>
                </div>
            </ng-template>
            <div
                *ngIf="existingSourceChips && existingSourceChips.length"
                class="agpr-searchSourcePicker-chips"
            >
                <agpr-scroll-panel>
                    <ul>
                        <li
                            *ngFor="let chip of existingSourceChips; let i = index"
                            [id]="id + '_existingSources_chip_' + i"
                            class="agpr-chip"
                            [attr.aria-label]="chip.label"
                        >
                            <span
                                class="agpr-chip-label"
                            >
                                {{ chip.label }}
                            </span>
                            <span
                                class="agpr-chip-type"
                            >
                                {{ chip.type }}
                            </span>
                            <button
                                [id]="id + '_existingSources_chip_' + i + '_delete'"
                                class="agpr-chip-icon agpr-i-close"
                                agprTooltip="Common.forms.chips.delete"
                                [useTooltipAsAriaLabel]="false"
                                tooltipPosition="top"
                                (click)="existingSourceRemoved(chip)"
                                [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                            ></button>
                        </li>
                    </ul>
                </agpr-scroll-panel>
            </div>
        </div>
        <div class="agpr-searchSourcePicker-create">
            <agpr-create-source-input
                [id]="id + '_newSources'"
                label="Sources.sourcePicker.createAdd"
                (sourcesAdded)="newSourcesAdded($event)"
                (sourceRemoved)="removeFromValue($event)"
            ></agpr-create-source-input>
        </div>
    </div>
</div>
